// extracted by mini-css-extract-plugin
export default {"applyButton":"Journey_applyButton__srHOu","responsiveVideo":"Journey_responsiveVideo__t9odY"};